"use client";

import React, { useState, useEffect } from "react";
import Image from "next/image";
import { useRouter } from "next/router";
import { handleAddCart, getTotals } from "../../../lib/store/Slices/CartSlice";
import { useAppDispatch } from "@/lib/store/hooks";
import MakeOffer from "../../MakeOffer/MakeOffer";
import LoginModal from "../../LoginPage/LoginModal";
import ProductImageLoader from "./ProdcutSkeleton";
import { useRef } from "react";
import { Popover, OverlayTrigger } from "react-bootstrap";
import { Button, Tag, Tooltip } from "antd";
import { Flame, Droplet } from "lucide-react";
import { ShoppingCartOutlined, DollarOutlined } from "@ant-design/icons";
import * as appConstants from "../../../utils/constants";
import "./InventoryProduct.css";
import Swal from "sweetalert2";

import {
  setCategory,
  setIndustry,
  setType,
} from "../../../lib/store/Slices/FilterSlice";

import { isNewArrival } from "@/utils/dateUtils";

function InventoryProduct(props) {
  const dispatch = useAppDispatch();
  const router = useRouter();
  const [show, setshow] = useState(null);
  const [showLogin, setShowLogin] = useState(null);
  const [isBuyNow, setIsBuyNow] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(true);
  const [loginData, setLoginData] = useState({});
  const [fadeEffect, setFadeEffect] = useState("fade-in");
  const badgeRef = useRef(null);

  const { industryName = "", title = "", id } = props;

  // Convert industryName and title to lowercase and replace spaces and special characters with hyphens
  const formattedIndustryName = props.productDetail.industryName
    ?.toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");

  const formattedTitle = props.productDetail.description
    ?.toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");

  useEffect(() => {
    const storedLoginData = JSON.parse(localStorage.getItem("login")) || {};
    setLoginData(storedLoginData);
  }, []);
  const handleshow = () => {
    if (show === null) {
      if (show === null) {
        setshow(true);
      }
    } else {
      setshow(!show);
    }
  };

  const handleOfferClose = () => {
    setshow(false);
  };

  const gotToInventoryByIndustry = (item) => {
    // console.log(item);
    if (item && item.id) {
      var selectItem = {
        id: item.relatedIndustrId,
        name: item.industryName,
      };
      dispatch(setIndustry(selectItem));
      window.scrollTo(0, 0);
      // router.push("/Inventory");
    }
  };

  const gotToInventoryByCategory = (item) => {
    if (item && item.id) {
      var selectItem = {
        id: item.relatedCategoryId,
        name: item.categoryName,
      };
      dispatch(setCategory(selectItem));
      window.scrollTo(0, 0);
      router.push("/Inventory");
    }
  };

  const gotToInventoryByType = (item) => {
    if (item && item.id) {
      var selectItem = {
        id: item.relatedTypeId,
        name: item.typeName,
      };
      dispatch(setType(selectItem));
      window.scrollTo(0, 0);
      router.push("/Inventory");
    }
  };

  // console.log("🔍 Checking NEW ARRIVAL:");
  // console.log("📅 createDate =", props.productDetail.createDate);
  // console.log(
  //   "🧮 isNewArrival =",
  //   isNewArrival(props.productDetail.createDate)
  // );

  const handleTitleClick = () => {
    // Trigger the fade effect when title is clicked
    setFadeEffect("fade-out");
    setTimeout(() => setFadeEffect("fade-in"), 1000); // Reset fade effect after 1 second
  };

  const handleSwal = () => {
    Swal.fire({
      title: "Thanks for shopping with us",
      text: "Item added to cart successfully",
      icon: "success",
      showCancelButton: true,
      cancelButtonText: "Continue Shopping",
      confirmButtonColor: "#043289",
      cancelButtonColor: "#043289",
      confirmButtonText: "Go to Checkout",
    }).then((result) => {
      if (result.isConfirmed) {
        router.push("/shopping-cart");
      }
    });
  };

  // Frenzy Alert Badge with Popover instead of Tooltip
  const renderFrenzyAlertBadge = () => {
    const popover = (
      <Popover id="frenzy-alert-popover" className="popover-wide">
        <Popover.Body>
          <strong>
            🩸 Blood’s in the water. The feeding frenzy has begun act now or get
            left behind. <br></br>
          </strong>
          This item is gaining rapid attention. It’s priced aggressively,
          available in limited quantity, and moving quickly. First come, first
          served. Once it’s gone — it’s gone.
        </Popover.Body>
      </Popover>
    );

    return (
      <OverlayTrigger
        trigger={["hover", "focus"]}
        placement="bottom"
        overlay={popover}
        // delay={{ show: 250, hide: 400 }}
      >
        <div
          className="d-inline-flex align-items-center frenzy-badge"
          style={{
            height: "40px",
            padding: "0 12px",
            backgroundColor: "#fff",
            color: "black",
            padding: "5px",
            borderRadius: "4px",
            borderLeft: "4px solid red",
            boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
            cursor: "help",
          }}
        >
          {/* <Droplet size={20} color="#fb1818" strokeWidth={2.25} /> */}
          <Droplet size={20} color="red" fill="#fb1818" className="me-2" />
          <div className="d-flex flex-column">
            <span
              className="fw-bold"
              style={{ fontSize: "0.875rem", lineHeight: "1.2" }}
            >
              FRENZY ALERT
            </span>
            <span style={{ fontSize: "0.75rem", lineHeight: "1.2" }}>
              Blood in the Water
            </span>
          </div>
        </div>
      </OverlayTrigger>
    );
  };
  function buyNow(selectedItem) {
    dispatch(handleAddCart(selectedItem));
    dispatch(getTotals());
    fetch("/api/AddToCartNotification", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        itemName: selectedItem.description,
        clarityUserId: localStorage.getItem("clarity_user_id") || "N/A",
        name: loginData?.name || "Guest",
        qty: 1,
        userEmail: loginData?.email || "Guest",
        address: loginData?.address || "Guest",
        price: selectedItem.salePrice,
      }),
    })
      .then((res) => {
        if (!res.ok) throw new Error("Failed to send add-to-cart email");
        console.log("✅ Add-to-cart email sent");
      })
      .catch((err) => {
        console.error("❌ Error sending email:", err);
      });
    if (window.uetq) {
      window.uetq.push({
        ea: "BuyNow", // Event Action
        el: selectedItem.title, // Event Label (e.g., product name)
        ev: selectedItem.salePrice, // Event Value (e.g., product price or revenue)
      });
    }
    router.push("/shopping-cart");
  }

  const addCart = (selectedItem) => {
    dispatch(handleAddCart(selectedItem));
    dispatch(getTotals());
    handleSwal();

    if (loginData) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: "add_to_cart",
        ecommerce: {
          currency: "USD",
          value: selectedItem.salePrice,
          items: [
            {
              item_name: selectedItem.description,
              item_id: selectedItem.id,
              price: selectedItem.salePrice,
              item_brand: selectedItem.brandName,
              item_category: selectedItem.categoryName,
              item_list_name: "Inventory Detail Page",
              index: 0,
              quantity: 1,
            },
          ],
        },
      });
    }

    fetch("/api/AddToCartNotification", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        itemName: selectedItem.description,
        clarityUserId: localStorage.getItem("clarity_user_id") || "N/A",
        name: loginData?.name || "Guest",
        qty: 1,
        userEmail: loginData?.email || "Guest",
        address: loginData?.address || "Guest",
        price: selectedItem.salePrice,
      }),
    })
      .then((res) => {
        if (!res.ok) throw new Error("Failed to send add-to-cart email");
        console.log("✅ Add-to-cart email sent");
      })
      .catch((err) => {
        console.error("❌ Error sending email:", err);
      });

    if (window.uetq) {
      window.uetq.push({
        ea: "AddToCart", // Event Action
        el: selectedItem.title, // Event Label (e.g., product name)
        ev: selectedItem.salePrice, // Event Value (e.g., product price)
      });
    }
  };

  // function addCart(selectedItem) {
  //   var loginData = JSON.parse(localStorage.getItem("login"));

  //   if (loginData == null) {
  //     setIsBuyNow(false);
  //     dispatch(handleAddCart(selectedItem));
  //     dispatch(getTotals());
  //     Swal.fire({
  //       title: "Thanks for shopping with us",
  //       text: "Item added to cart successfully",
  //       icon: "success",
  //       showCancelButton: true,
  //       cancelButtonText: "Continue Shopping",
  //       confirmButtonColor: "#043289",
  //       cancelButtonColor: "#043289",
  //       confirmButtonText: "Go to Checkout",
  //     }).then((result) => {
  //       if (result.isConfirmed) {
  //         router.push("/ShoppingCart");
  //       }
  //     });
  //   } else {
  //     dispatch(handleAddCart(selectedItem));
  //     dispatch(getTotals());
  //     Swal.fire({
  //       title: "Thanks for shopping with us",
  //       text: "Item added to cart successfully",
  //       icon: "success",
  //       showCancelButton: true,
  //       cancelButtonText: "Continue Shopping",
  //       confirmButtonColor: "#043289",
  //       cancelButtonColor: "#043289",
  //       confirmButtonText: "Go to Checkout",
  //     }).then((result) => {
  //       if (result.isConfirmed) {
  //         router.push("/ShoppingCart");
  //       }
  //     });
  //     // console.log(selectedItem);
  //     // ReactGA.event({
  //     //   category: "Add to Cart",
  //     //   action: "Add to Cart",
  //     //   label: selectedItem.description,
  //     // });

  // function detailPage() {
  //   const queryParams = itemQuaryParams();
  //   window.open(
  //     `/InventoryDetail/${props.productDetail.id}?${queryParams.toString()}`,
  //     "_blank"
  //   );
  // }

  const extractImageUrl = (htmlString) => {
    if (typeof window === "undefined") {
      // Server-side: Use a simple regex to extract the src
      const match = htmlString.match(/<img.*?src=["'](.*?)["']/);
      return match ? match[1] : "/assets/images/not-found.png";
    } else {
      // Client-side: Use DOMParser
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlString, "text/html");
      const imgElement = doc.querySelector("img");
      return imgElement ? imgElement.src : "/assets/images/not-found.png";
    }
  };

  function handleCallToActionClick() {
    // Additional logic for initiating call
  }

  function detailPage() {
    // e.preventDefault();
    // const queryParams = itemQuaryParams();
    // router.push(`/InventoryDetail/${props.productDetail.id}`, { replace: true });
    // router.push(`/InventoryDetail/${props.productDetail.id}`, undefined, {
    //   replace: true,
    // });
    handleTitleClick();
    // const url = `https://kingsurplus.com${props.productDetail.productSlug}`;
    const url = `/${props.productDetail.productSlug}`;
    // window.location.href(url);
    window.location.href(url);
  }

  // function itemQuaryParams() {
  //   const item = {
  //     industry: props.productDetail.industryName,
  //     category: props.productDetail.categoryName,
  //     type: props.productDetail.typeName,
  //     description: props.productDetail.description,
  //     assetNo: props.productDetail.assetNumber,
  //     location: props.productDetail.location,
  //     model: props.productDetail.model,
  //     manufacturer: props.productDetail.menufacturer,
  //   };
  //   const queryParams = new URLSearchParams();
  //   queryParams.set("item", JSON.stringify(item));
  //   return queryParams;
  // }

  // const handleImageLoad = () => {
  //   setImageLoaded(true);
  // };

  // const handleImageError = () => {
  //   // Handle image loading errors here
  //   setImageLoaded(true);
  // };

  // function detailPageMobile() {
  //   sessionStorage.setItem("scrollPosition", window.pageYOffset);
  //   const queryParams = itemQuaryParams();
  //   navigate(
  //     `/InventoryDetail/${props.productDetail.id}?${queryParams.toString()}`,
  //     { state: { id: props.id } }
  //   );
  // }

  function detailPageMobile() {
    // const queryParams = itemQuaryParams();
    // router.push(`/InventoryDetail/${props.productDetail.id}`, { replace: true });
    const targetUrl = `${props.productDetail.productSlug}`;
    if (router.asPath !== targetUrl) {
      router.push(targetUrl, undefined, { replace: true });
    }
  }

  function appriasedValueExit() {
    if (props.productDetail.salePrice && props.productDetail.salePrice > 0) {
      return true;
    } else {
      return false;
    }
  }
  return (
    <>
      {/* Desktop Prodcut Card */}
      <div className="productItem-wrap DesktopProduct ">
        {(() => {
          if (props.productDetail.coverImageURL) {
            const imageUrl = extractImageUrl(props.productDetail.coverImageURL);

            return (
              <div>
                {imageLoaded ? (
                  <div className="productItem-Img">
                    {props.productDetail.coverImageURL ? (
                      <div
                        className="productItem-Img"
                        id={`product-${appConstants.formattedValue(
                          props.productDetail.id
                        )}`}
                        onClick={() => {
                          detailPage();
                        }}
                      >
                        <img
                          src={imageUrl}
                          alt={props.productDetail.description}
                          width={100}
                          height={100}
                          //       layout="lazy"
                          //       sizes="(max-width: 768px) 100vw,
                          //  (max-width: 1200px) 50vw,
                          //  33vw"
                        />
                        {isNewArrival(props.productDetail.createDate) && (
                          <div className="new-arrival-overlay">New Arrival</div>
                        )}
                        {/* {props.productDetail.isFreeShipping === true && (
                          <div className="free-shipping-overlay">
                            Free Shipping
                          </div>
                        )} */}
                        {/* <div className="hot-overlay">
                          {renderFrenzyAlertBadge()}
                        </div> */}
                      </div>
                    ) : (
                      <img
                        src="/assets/images/not-found.png"
                        alt="Not Found Image"
                        width={100}
                        height={100}
                      />
                    )}
                  </div>
                ) : (
                  <ProductImageLoader />
                )}
              </div>
            );
          } else {
            return (
              <div className="productItem-Img">
                {" "}
                <Image
                  src="/assets/images/not-found.png"
                  alt="Not Found Image"
                  height={100}
                  width={100}
                />{" "}
              </div>
            );
          }
        })()}

        <div className="productItem-Info ">
          <a
            href={`https://kingsurplus.com${props.productDetail.productSlug}`}
            // href={`/${props.productDetail.productSlug}`}
            passHref
            target="_blank"
            scroll={true}
          >
            <h4 className={`title_link`}>{props.productDetail.description}</h4>
          </a>

          {props.productDetail.isHotSale ? (
            <div style={{ margin: "10px 0" }}>{renderFrenzyAlertBadge()}</div>
          ) : (
            <>
              <ul className="advertising-wrap">
                {props.productDetail.industryName !== null && (
                  <li className="industry_name">
                    <a
                      href={`https://kingsurplus.com/${props.productDetail.industrySlug}`}
                    >
                      {props.productDetail.industryName}
                    </a>
                  </li>
                )}
              </ul>
              <ul className="list-wrap">
                <li>
                  <p>
                    <strong>Location:</strong> {props.productDetail.location}
                  </p>
                </li>
              </ul>
            </>
          )}

          <div>
            {props.productDetail.quantity > 0 && (
              <Tag color="green" style={{ fontWeight: 600 }}>
                Available Quantity : {props.productDetail.quantity}
              </Tag>
            )}
            {props.productDetail.isSpecializedFreightTransit === true && (
              <Tag color="blue">Specialized Freight Transit</Tag>
            )}
            {props.productDetail.isLocalPickupOnly === true && (
              <Tag color="blue">Pickup Only</Tag>
            )}
            {props.productDetail.isFreeShipping === true && (
              <Tag color="green">Free Shipping</Tag>
            )}
          </div>
          {appriasedValueExit() && (
            // <h5> ${appConstants.formattedValue(props.productDetail.salePrice)}</h5>
            <h5 className="salePrice">
              ${appConstants.formattedValue(props.productDetail.salePrice)}
            </h5>
          )}

          {!appriasedValueExit() && <h5 className="my-5"> {""} </h5>}

          <div className="btn-wrap">
            {appriasedValueExit() && (
              <a
                // href="/#"
                className="btn btn-blue buy-now-button"
                onClick={() => buyNow(props.productDetail)}
              >
                Buy Now
              </a>
            )}
            <div
              className="flex-desk-btn"
              style={{ display: "flex", gap: "10px" }}
            >
              {appriasedValueExit() && (
                <Button
                  className="secondry-btn"
                  defaultActiveBg="#043289"
                  style={{ height: "40px", borderRadius: "5px" }}
                  onClick={() => addCart(props.productDetail)}
                >
                  Add to Cart
                </Button>
              )}
              {/* <a onClick={handleshow} className="">
              Make an Offer
            </a> */}
              <Button
                className="secondry-btn"
                defaultActiveBg="#043289"
                style={{ height: "40px", borderRadius: "5px" }}
                onClick={handleshow}
              >
                Make an Offer
              </Button>
            </div>
          </div>
        </div>
        {show !== null && (
          <MakeOffer
            item={props.productDetail}
            close={handleOfferClose}
            show={show}
          />
        )}

        <LoginModal
          item={props.productDetail}
          show={showLogin}
          isBuyNow={isBuyNow}
        />
      </div>

      {/* Mobile Prodcut Card */}
      <div className="productItem-wrap MobileProduct">
        {(() => {
          if (props.productDetail.coverImageURL) {
            const imageUrl = extractImageUrl(props.productDetail.coverImageURL);

            return (
              <div>
                <div
                  className="productItem-Img"
                  //  id={`product-${appConstants.formattedValue(props.productDetail.id)}`}
                  id={`product-${props.productDetail.id.toString()}`}
                  onClick={() => {
                    // detailPage();
                    window.location.href = `https://kingsurplus.com${props.productDetail.productSlug}`;
                    // window.location.href = `/${props.productDetail.productSlug}`;
                  }}
                  // dangerouslySetInnerHTML={{
                  //   __html: props.productDetail.coverImageURL,
                  // }}
                >
                  <img
                    src={imageUrl}
                    alt={props.productDetail.description}
                    width={100}
                    height={100}
                    layout="responsive"
                    // loading="lazy"
                    // sizes="(max-width: 768px) 100vw,
                    //  (max-width: 1200px) 50vw,
                    //  33vw"
                  />
                  {isNewArrival(props.productDetail.createDate) && (
                    <div className="new-arrival-overlay">New Arrival</div>
                  )}
                  {/* {props.productDetail.isFreeShipping === true && (
                    <div className="free-shipping-overlay">Free Shipping</div>
                  )} */}
                </div>
              </div>
            );
          } else {
            // return <img src={props.productDetail.coverImageURL}/>
            return (
              <div className="productItem-Img">
                {" "}
                <Image
                  src="/assets/images/not-found.png"
                  alt="Not Found Image"
                  height={100}
                  width={100}
                />{" "}
              </div>
            );
          }
        })()}

        <div className="productItem-Info">
          {/* <Link to="/" className="heart-Ico heart-Ico2">
          <Icon icon="akar-icons:heart" />
        </Link> */}

          <a
            href={`https://kingsurplus.com${props.productDetail.productSlug}`}
            // href={`/${props.productDetail.productSlug}`}

            scroll={true}
          >
            <h4
              // className="title_link"
              className={`title_link ${fadeEffect}`}
            >
              {props.productDetail.description}
            </h4>
          </a>
          <ul className="advertising-wrap">
            {props.productDetail.industryName !== null && (
              <li>
                <a href="/#">{props.productDetail.industryName}</a>
              </li>
            )}
            {props.productDetail.categoryName !== null && (
              <li>
                <a href="/#">{props.productDetail.categoryName}</a>
              </li>
            )}
            {props.productDetail.typeName !== null && (
              <li>
                <a href="/#">{props.productDetail.typeName}</a>
              </li>
            )}
          </ul>
          {props.productDetail.isHotSale ? (
            <div style={{ margin: "10px 0" }}>{renderFrenzyAlertBadge()}</div>
          ) : (
            <>
              <ul className="advertising-wrap">
                {props.productDetail.industryName !== null && (
                  <li className="industry_name">
                    <a
                      href={`https://kingsurplus.com/${props.productDetail.industrySlug}`}
                    >
                      {props.productDetail.industryName}
                    </a>
                  </li>
                )}
              </ul>
              <ul className="list-wrap">
                <li>
                  <p>
                    <strong>Location:</strong> {props.productDetail.location}
                  </p>
                </li>
              </ul>
            </>
          )}
          <div className="pills">
            {props.productDetail.quantity > 0 && (
              <Tag color="green" style={{ fontWeight: 600 }}>
                Available Quantity :{" "}
                <strong>{props.productDetail.quantity}</strong>
              </Tag>
            )}
            {/* {isHotSelling && ( */}

            {/* {renderFrenzyAlertBadge()} */}
            {/* )} */}
            {props.productDetail.isSpecializedFreightTransit === true && (
              <Tag color="blue" style={{ margin: "5px" }}>
                Specialized Freight Transit
              </Tag>
            )}
            {props.productDetail.isLocalPickupOnly === true && (
              <Tag color="blue" style={{ margin: "5px" }}>
                Pickup Only
              </Tag>
            )}
            {props.productDetail.isFreeShipping === true && (
              <Tag color="green" style={{ margin: "5px" }}>
                Free Shipping
              </Tag>
            )}
          </div>

          {appriasedValueExit() && (
            <h5 className="salePrice">
              ${appConstants.formattedValue(props.productDetail.salePrice)}
            </h5>
          )}

          {!appriasedValueExit() && <h5 className="my-5"> {""} </h5>}
          <div className="btn-wrap">
            {appriasedValueExit() && (
              <Button
                className="btn btn-blue"
                href="/shopping-cart"
                style={{ height: "40px", borderRadius: "5px" }}
                onClick={() => buyNow(props.productDetail)}
              >
                Buy Now
              </Button>
            )}
            <div className="flex-md">
              {appriasedValueExit() && (
                <Button
                  className="secondry-btn secondry-btn-mobile"
                  defaultActiveBg="#043289"
                  style={{ height: "40px", borderRadius: "5px" }}
                  onClick={() => addCart(props.productDetail)}
                >
                  <ShoppingCartOutlined /> Add to Cart
                </Button>
              )}
              <Button
                className="secondry-btn secondry-btn-mobile"
                defaultActiveBg="#043289"
                style={{ height: "40px", borderRadius: "5px" }}
                onClick={handleshow}
              >
                <DollarOutlined /> Make an Offer
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default InventoryProduct;
